import type { Confidence, Context } from '@spotify-confidence/sdk';
import { createContext } from 'react';

// Type-only import above, and no other value import than React's: this module exists so a
// caller that only needs the context or its type can reach them without the Confidence SDK
// following. A value import here would drag the whole client into every eager bundle that
// touches the context — the widget's `embed` entry among them, where it does not fit.
type ConfidenceClient = ReturnType<typeof Confidence.create>;

export type ConfidenceCtxValue = {
  client: ConfidenceClient;
  updateContext: (patch: Context) => void;
  setDeviceId: (deviceId: string) => void;
  isReady: boolean;
};

export const ConfidenceContext = createContext<ConfidenceCtxValue | null>(null);
